import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-2 justify-center" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Phone", -1)
const _hoisted_4 = { class: "flex flex-row w-full" }
const _hoisted_5 = {
  key: 0,
  class: "block"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "OTP", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  id: "sign-in-button",
  class: ""
}, null, -1)
const _hoisted_8 = {
  key: 2,
  class: "flex justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Verify OTP", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Sign in with Phone", -1)

import {DevicePhoneMobileIcon} from "@heroicons/vue/24/solid";
import {onMounted, ref} from "vue";
import { signInWithPhoneNumber, RecaptchaVerifier, getAuth } from "firebase/auth";
import LoadingComponent from "@/components/LoadingComponent.vue";
import {VueTelInput} from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneLoginComponent',
  props: {
    onClose: { type: Function }
  },
  setup(__props: any) {

/* global grecaptcha */
const loading = ref(false)
const auth = getAuth();

const verifiedRecaptcha = ref(false)

const props = __props;

const phone = ref('')
const otp = ref('')
const isOtpSent = ref(false)

const onPhoneChanged = (value: string, phoneObject: any) => {
  if(phoneObject) {
    phone.value = phoneObject.number
  }
}

const sendOTP = () => {
  if(phone.value.length < 10) {
    alert('Please enter a valid phone number')
    return
  }
  loading.value = true
  const appVerifier = window.recaptchaVerifier;
  signInWithPhoneNumber(auth, phone.value, appVerifier)
      .then((confirmationResult) => {
        isOtpSent.value = true
        loading.value = false
        window.confirmationResult = confirmationResult;
      }).catch((error) => {
    loading.value = false
    alert('Failed to send SMS ' + error)

    window.recaptchaVerifier.render().then(function(widgetId: any) {
      grecaptcha.reset(widgetId);
    });
  });
}

const verifyOTP = () => {
  loading.value = true
  window.confirmationResult.confirm(otp.value).then((result: any) => {
    // localStorage.clear();
    setTimeout(() => {
      window.location.reload();
    })
    loading.value = false
  }).catch((error: any) => {
    loading.value = false
    alert('Failed to verify OTP ' + error)
  });
}

onMounted(() => {
  window.recaptchaVerifier = new RecaptchaVerifier(auth, 'sign-in-button', {
    'size': 'invisible',
    'callback': (response: any) => {
      verifiedRecaptcha.value = true
    }
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(VueTelInput), {
          onInput: onPhoneChanged,
          modelValue: phone.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
          class: "w-full rounded-md"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (isOtpSent.value)
      ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otp).value = $event)),
            maxlength: "6",
            class: "mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0",
            placeholder: ""
          }, null, 512), [
            [_vModelText, otp.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_7,
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingComponent, { key: 1 }))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (isOtpSent.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: verifyOTP,
                class: "bg-brand text-brand-text mt-6 font-bold space-x-2 px-4 py-2 rounded-md flex flex-row"
              }, _hoisted_10))
            : _createCommentVNode("", true),
          (!isOtpSent.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: sendOTP,
                class: "bg-brand text-brand-text mt-6 font-bold space-x-2 px-4 py-2 rounded-md flex flex-row"
              }, [
                _createVNode(_unref(DevicePhoneMobileIcon), { class: "h-6 w-6" }),
                _hoisted_11
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
      class: "text-sm text-brand-text opacity-75 pt-8 text-center"
    }, " Back ")
  ]))
}
}

})